import { getDefaultMargin, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const LinearProgressDesignSettings = {
  // Dimension
  'linear-progress-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'linear-progress-design-height': {
    phone: [10],
    'phone-landscape': [10],
    tablet: [10],
    'tablet-landscape': [10],
    desktop: [10],
    tv: [10],
  },
  // Margin
  'linear-progress-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'linear-progress-design-title-margin': {
    phone: getDefaultMargin([20, 0, 20, 0]),
    'phone-landscape': getDefaultMargin([20, 0, 20, 0]),
    tablet: getDefaultMargin([20, 0, 20, 0]),
    'tablet-landscape': getDefaultMargin([20, 0, 20, 0]),
    desktop: getDefaultMargin([20, 0, 20, 0]),
    tv: getDefaultMargin([20, 0, 20, 0]),
  },
  // Alignment
  'linear-progress-design-alignment': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'linear-progress-value-alignment': {
    phone: 'end',
    'phone-landscape': 'end',
    tablet: 'end',
    'tablet-landscape': 'end',
    desktop: 'end',
    tv: 'end',
  },
  // Typography
  'linear-progress-design-typography': {
    phone: getDefaultTypography('Body Medium'),
    'phone-landscape': getDefaultTypography('Body Medium'),
    tablet: getDefaultTypography('Body Medium'),
    'tablet-landscape': getDefaultTypography('Body Medium'),
    desktop: getDefaultTypography('Body Medium'),
    tv: getDefaultTypography('Body Medium'),
  },
  'linear-progress-design-heading-typography': {
    phone: getDefaultTypography('Body Medium'),
    'phone-landscape': getDefaultTypography('Body Medium'),
    tablet: getDefaultTypography('Body Medium'),
    'tablet-landscape': getDefaultTypography('Body Medium'),
    desktop: getDefaultTypography('Body Medium'),
    tv: getDefaultTypography('Body Medium'),
  },
  'linear-progress-design-value-typography': {
    phone: getDefaultTypography('Body Medium'),
    'phone-landscape': getDefaultTypography('Body Medium'),
    tablet: getDefaultTypography('Body Medium'),
    'tablet-landscape': getDefaultTypography('Body Medium'),
    desktop: getDefaultTypography('Body Medium'),
    tv: getDefaultTypography('Body Medium'),
  },
  'linear-progress-design-value-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'linear-progress-design-value-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'linear-progress-design-value-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'linear-progress-design-value-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'linear-progress-design-value-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
}
